import { VirtualArrayKey, VirtualDomItemType, VirtualDomNode } from "./type";
import { v4 as uuidV4 } from "uuid";

export class JsonToDomService {
  /**
   * 更新选中状态
   */
  public updatedSelected() {}

  //转换JSON数据为节点
  public getVirtualDomByJson(json: any): any {
    if (typeof json === VirtualDomNode.object && json !== null) {
      if (Array.isArray(json)) {
        return {
          uuid: uuidV4(),
          type: VirtualDomNode.array,
          isSelected: false,
          children: json.map((item) => this.getVirtualDomByJson(item)),
        };
      } else {
        return {
          type: VirtualDomNode.object,
          children: Object.keys(json)
            .map((key) => {
              //_$开头处理为对应label
              if (!key.startsWith("_$")) {
                const labelKey = `_$${key}`;
                return {
                  key,
                  uuid: uuidV4(),
                  type: this.getType(json[key]),
                  value: json[key],
                  label: json[labelKey],
                  isSelected: false,
                  children: this.getVirtualDomByJson(json[key]).children, //不要多嵌套一层
                  arrayKey: VirtualArrayKey.inputIndex,
                };
              }
            })
            ?.filter((item) => item),
        };
      }
    } else {
      return {
        uuid: uuidV4(),
        type: this.getType(json),
        value: json,
        isSelected: false,
      };
    }
  }

  public getType(value: any): any {
    if (value === null) {
      return "null";
    }
    if (Array.isArray(value)) {
      return "array";
    }
    if (value instanceof Date) {
      return "date";
    }
    if (value instanceof RegExp) {
      return "regexp";
    }
    const type = typeof value;
    if (type === "object") {
      return "object";
    }
    return type;
  }

  /**
   * 获取节点的className 不同类型的值展示不同的颜色
   */
  public getClassNameByNode(nodeType: VirtualDomNode) {
    switch (nodeType) {
      case VirtualDomNode.array:
        return "arrayData"
      case VirtualDomNode.object:
        return "objectData"
      case VirtualDomNode.boolean:
        return "booleanData"
      case VirtualDomNode.number:
        return "numberData"
      case VirtualDomNode.string:
        return "stringData"
      case VirtualDomNode.null:
        return "nullData"
      case VirtualDomNode.undefined:
        return "undefinedData"
      default:
        return "undefinedData"
    }
  }
}
